import { useEffect, useState } from 'react';
import { sanitize } from 'helpers/basicFunctions';
import { getGuideCampaigns } from './Cards.services';
import { useToast } from '@welbe/web-design-system';

interface UseCardsProps {
	campaignId: string;
	selectedBranchOfficeId: string;
}

export const useCards = ({
	campaignId,
	selectedBranchOfficeId,
}: UseCardsProps) => {
	const { toast } = useToast();
	const [dataGuideCampaigns, setDataGuideCampaigns] = useState([]);
	const [isLoading, setLoading] = useState(false);

	const formattedBranchOfficeId =
		selectedBranchOfficeId === 'total' ? undefined : selectedBranchOfficeId;

	const filters = sanitize({ branchOfficeId: formattedBranchOfficeId });

	const fetchGuideInfoCampaigns = async () => {
		setLoading(true);
		try {
			const { data } = await getGuideCampaigns(campaignId, filters);
			setDataGuideCampaigns(data.content);
		} catch (error) {
			toast.error(
				'Hubo un error al intentar procesar esta operación. Inténtalo de nuevo más tarde.',
			);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchGuideInfoCampaigns();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campaignId, selectedBranchOfficeId]);

	return {
		isLoading,
		dataGuideCampaigns: dataGuideCampaigns,
	};
};
